/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
/* eslint-disable radix */

import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import './searchBar';
import './uspTiles';
import { debounce, openVideoInModal } from './util';
import ContentHeroBanner from './contentHeroBanner';
import PromoBanner from './promoBanner';
import tooltip from './components/tooltip';

const ArticlePage = (() => {
    function toggeAddonDetails() {
        $('.js-details-trigger').on('click', (e) => {
            $(e.currentTarget).closest('.details-wrapper').toggleClass('open');
        });
    }

    function handleSwiper() {
        new Swiper('.js-image-carousel', {
            // configure Swiper to use modules
            modules: [Navigation, Pagination, A11y],
            loop: true,
            spaceBetween: 10,
            slidesPerView: 1, // dont use 'auto' see documentation
            centeredSlides: true,
            slidesOffsetBefore: 0,
            touchEventsTarget: 'wrapper',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            a11y: {
                prevSlideMessage: `${window.resources['slider.prev.slide.label']}`,
                nextSlideMessage: `${window.resources['slider.next.slide.label']}`,
                firstSlideMessage: `${window.resources['slider.first.slide.label']}`,
                lastSlideMessage: `${window.resources['slider.last.slide.label']}`,
            },
        });
    }

    function uspSliderLengthHandler() {
        const length = document.querySelectorAll('.usp-slide').length;
        const mapLength = { 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five' };
        const classLength = mapLength[length] ? mapLength[length] : null;
        const uspSlider = document.querySelector('.usp-swiper');
        if (uspSlider) {
            uspSlider.classList.add(classLength);
        }
    }

    function marqueeAnimationHandler() {
        if(document.querySelector('.page-wide-marquee')) {
            document.querySelector('.page-wide-marquee').classList.add('animate');
        } else {
            return;
        }
    }

    function startsWithPolyfill(searchString, position = 0) {
        return this.indexOf(searchString, position) === position;
    }

    function addIEPolyfill() {
        if (!String.prototype.startsWith) {
            // eslint-disable-next-line no-extend-native
            String.prototype.startsWith = startsWithPolyfill;
        }
    }

    function handleModal() {
        $('.js-video-button').on('click', (e) => {
            const videoUrl = $(e.currentTarget).data('video');
            openVideoInModal(videoUrl);
        });
    }

    function filterBlogs() {
        $('.js-blog-filter').on('click', (e) => {
            const $filter = $(e.currentTarget);
            if (!$filter.hasClass('selected')) {
                $(document).trigger('blogFilterClicked', [$filter.data('id')]);
            }
        });
    }

    function socialShareBlog() {
        $('.js-social-share').on('click', (e) => {
            const $social = $(e.currentTarget);
            $(document).trigger('blogSocialShareClicked', [$social.data('name')]);
        });
    }

    function countWords() {
        let wordCount = 0;
        const blogText = $('.js-article-text').text();
        if (blogText !== '') {
            wordCount = blogText.replace(/\s+/g, ' ').trim().split(' ').length;
        }
        return wordCount;
    }

    function fetchBlogData() {
        const $blogDetails = $(document).find('.blog-detail-page');
        if ($blogDetails.length > 0) {
            const image = $('.js-blog-image').val();
            const name = $('.js-blog-name').val();
            const publishDate = $('.js-blog-date').val();
            const publishDateDay = $('.js-blog-day').val();
            const publishDateMonth = $('.js-blog-month').val();
            const publishDateYear = $('.js-blog-year').val();
            const wordCount = countWords();
            const blogObject = {
                image,
                name,
                publishDate,
                publishDateDay,
                publishDateMonth,
                publishDateYear,
                wordCount,
            };
            $(document).trigger('blogPageLoaded', [blogObject]);
        }
    }

    function initTooltip() {
        if ($(window).width() < 1025) {
            tooltip.initMembershipTooltip();
        }
    }

    return {
        init() {
            marqueeAnimationHandler();
            uspSliderLengthHandler();
            PromoBanner;
            ContentHeroBanner;
            toggeAddonDetails();
            handleSwiper();
            addIEPolyfill();
            handleModal();
            filterBlogs();
            socialShareBlog();
            initTooltip();
        },
        load() {
            fetchBlogData();
        },
        scroll() {
            // loadNext();
        },
    };
})();

// Try to avoid to add functions in these 3 window/document events for readability purpose
export default (() => {
    // Dom Ready is Mandatory
    $(document).ready(ArticlePage.init);
    $(window)
        .on('load', ArticlePage.load)
        .on('scroll', debounce(ArticlePage.scroll, 700));
})();
